export default __webpack_public_path__ + "static/media/logo-md-1440w.1327c5aa.avif";